import { jsx as _jsx } from "react/jsx-runtime";
import ProjectsWorkspace from 'components/ProjectsWorkspace';
export default function ProjectsRoute() {
    return _jsx(ProjectsWorkspace, {});
}
